import { obterChamadosManutencaoAsync } from "../../services/chamadoManutencaoService";

const atualizarChamadosManutencao = async ({ commit }) => {
    const chamadosManutencao = await obterChamadosManutencaoAsync();
    commit('atualizarChamadosManutencao', chamadosManutencao);
}

const atualizarChamadoManutencao = ({ commit }, chamadoManutencao) => {
    commit('atualizarChamadoManutencao', chamadoManutencao);
}

const updateChamadoManutencao = ({ commit }, chamadoManutencao) => {
    commit('updateChamadoManutencao', chamadoManutencao);
}

export default {
    atualizarChamadosManutencao,
    atualizarChamadoManutencao,
    updateChamadoManutencao
}